import { Box, Button, FormControl, Drawer, IconButton, TextField, TextareaAutosize, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-hot-toast';
import { useFormik } from 'formik';
import CustomButtoncolor from '../custom-button/customColorButton';
import { setEmail } from '../../store/crm/crm';
import CancelIcon from '@mui/icons-material/Cancel';
import CloseIcon from '@mui/icons-material/Close';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';

const PRIMARY = "#A72C68";
const PRIMARY_LIGHT = "#FAEFF5";
const PRIMARY_BORDER = "#F0CDDB";
const PRIMARY_GRADIENT = "linear-gradient(135deg,#A72C68 0%,#921F58 100%)";

export const inputStyle = {
  background: '#fff',
  borderRadius: '10px',
  '& .MuiOutlinedInput-root': {
    borderRadius: '10px',
    '& fieldset': { borderColor: '#E5E7EB' },
    '&:hover fieldset': { borderColor: PRIMARY_BORDER },
    '&.Mui-focused fieldset': { borderColor: PRIMARY, borderWidth: '1.5px' },
  },
  '& .MuiOutlinedInput-input': {
    padding: '12px 14px',
    fontSize: '14px',
  },
};

const MAX_MSG = 5000;

const SetEmailModal = ({ customer_id, isbtn, fontsizee, paddingCRM }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const validate = (values) => {
    const errors = {};
    if (!values.message) errors.message = "Message is required";
    if (!values.subject) errors.subject = "Subject is required";
    return errors;
  };

  const formik = useFormik({
    initialValues: { message: '', subject: '' },
    validate,
    onSubmit: (values) => handleSentemail(values.message, values.subject),
  });

  const handleSentemail = async (message, subject) => {
    try {
      const payload = { customer_id, message, subject };
      dispatch(setEmail(payload));
      toast.success('Send Email Successfully');
      formik.resetForm();
      handleClose();
    } catch (error) {
      // handle error
    }
  };

  return (
    <>
      <CustomButtoncolor
        handleClick={handleOpen}
        mainColor={"#3d9621ed"}
        size="md"
        val="Send Email"
        style={{
          padding: paddingCRM || '10px 15px',
          fontSize: fontsizee || '14px',
          minWidth: 'max-content',
          borderRadius: '6px!important',
          width: '100%',
        }}
        icon={isbtn ? <CancelIcon /> : <EmailOutlinedIcon />}
      />

      <Drawer
        anchor="right"
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            width: { xs: '100%', sm: 480, md: 540 },
            background: '#fff',
            boxShadow: '-12px 0 40px rgba(0,0,0,0.10)',
          },
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              px: 2.5,
              py: 2,
              borderBottom: `1px solid ${PRIMARY_BORDER}`,
              flexShrink: 0,
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
              <Box
                sx={{
                  width: 38,
                  height: 38,
                  borderRadius: '10px',
                  background: PRIMARY_LIGHT,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: `1px solid ${PRIMARY_BORDER}`,
                }}
              >
                <EmailOutlinedIcon sx={{ color: PRIMARY, fontSize: 22 }} />
              </Box>
              <Typography sx={{ fontSize: '17px', fontWeight: 700, color: '#1a1a2e' }}>
                Send Email
              </Typography>
            </Box>
            <IconButton
              size="small"
              onClick={handleClose}
              sx={{
                color: '#6B7280',
                borderRadius: '8px',
                width: 32,
                height: 32,
                '&:hover': { background: PRIMARY_LIGHT, color: PRIMARY },
              }}
            >
              <CloseIcon sx={{ fontSize: 18 }} />
            </IconButton>
          </Box>

          <Box sx={{ flex: 1, overflowY: 'auto', px: 2.5, py: 2.5 }}>
            <Box sx={{ mb: 2.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 1 }}>
                <EmailOutlinedIcon sx={{ color: PRIMARY, fontSize: 16 }} />
                <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#1a1a2e' }}>
                  Subject
                </Typography>
              </Box>
              <FormControl fullWidth>
                <TextField
                  fullWidth
                  name="subject"
                  sx={inputStyle}
                  placeholder="Enter email subject..."
                  value={formik.values.subject}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={!!(formik.touched.subject && formik.errors.subject)}
                  helperText={formik.touched.subject && formik.errors.subject}
                />
              </FormControl>
            </Box>

            <Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 1 }}>
                <EditOutlinedIcon sx={{ color: PRIMARY, fontSize: 16 }} />
                <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#1a1a2e' }}>
                  Message
                </Typography>
              </Box>
              <Box
                sx={{
                  position: 'relative',
                  background: '#fff',
                  border: `1.5px solid ${PRIMARY}`,
                  borderRadius: '10px',
                  '&:focus-within': {
                    borderColor: PRIMARY,
                    boxShadow: `0 0 0 3px ${PRIMARY_LIGHT}`,
                  },
                }}
              >
                <TextareaAutosize
                  minRows={10}
                  maxRows={20}
                  name="message"
                  placeholder="Type your message here..."
                  style={{
                    width: '100%',
                    padding: '12px 14px',
                    border: 'none',
                    outline: 'none',
                    fontSize: '14px',
                    fontFamily: 'inherit',
                    resize: 'vertical',
                    borderRadius: '10px',
                    background: 'transparent',
                  }}
                  maxLength={MAX_MSG}
                  value={formik.values.message}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                <Typography
                  sx={{
                    position: 'absolute',
                    bottom: 6,
                    right: 12,
                    fontSize: '11px',
                    color: '#9CA3AF',
                    fontWeight: 500,
                    pointerEvents: 'none',
                  }}
                >
                  {(formik.values.message || '').length}/{MAX_MSG}
                </Typography>
              </Box>
              {formik.touched.message && formik.errors.message && (
                <Typography sx={{ fontSize: '12px', color: '#ef4444', mt: 0.5 }}>
                  {formik.errors.message}
                </Typography>
              )}
            </Box>
          </Box>

          <Box
            sx={{
              px: 2.5,
              py: 2,
              borderTop: `1px solid ${PRIMARY_BORDER}`,
              background: '#FDFBFC',
              display: 'flex',
              gap: 1.25,
              justifyContent: 'flex-end',
              flexShrink: 0,
              flexDirection: { xs: 'column-reverse', sm: 'row' },
            }}
          >
            <Button
              onClick={handleClose}
              sx={{
                textTransform: 'none',
                fontWeight: 600,
                borderRadius: '10px',
                backgroundColor: '#EB5757',
                color: '#fff',
                border: '1px solid #EB5757',
                boxShadow: 'none',
                px: 3.5,
                py: 1.1,
                '&:hover': { backgroundColor: '#fff', color: '#EB5757', border: '1px solid #EB5757', boxShadow: 'none' },
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={formik.handleSubmit}
              startIcon={<SendOutlinedIcon />}
              sx={{
                textTransform: 'none',
                fontWeight: 600,
                borderRadius: '10px',
                background: 'linear-gradient(135deg, #27AE60 0%, #1E8449 100%)',
                color: '#fff',
                border: '1px solid #27AE60',
                px: 3.5,
                py: 1.1,
                boxShadow: 'none',
                '&:hover': {
                  background: '#219653',
                  color: '#fff',
                  border: '1px solid #27AE60',
                  boxShadow: 'none',
                },
              }}
            >
              Send Email
            </Button>
          </Box>
        </Box>
      </Drawer>
    </>
  );
};

export default SetEmailModal;
